import httpClient from "http-client/http-client";

export async function listPortalLocations(params = {}) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/location/list",
    body: {
      current_page: params.current_page ?? 1,
      page_size: params.page_size ?? 10000,
    },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
